import React, { useEffect, useRef, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { t } from 'i18next';
import i18next from 'i18next';
import './style.css'
import { formatNumber, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';

function POWERBI_COMPONENT_KEY_KPIS(props) {

    const { 
		inputParam_ComponentContent = null,
    	inputParam_UseFake = false,
    } = props;

    const gridRef = useRef(null);

    const [data, setData] = useState(__OBJECT_STRUCTURE_GetList(15, !inputParam_UseFake ?
        
        inputParam_ComponentContent?.items.map(item => ({
            ...item,
            contractualText: item.contractual === true ? t("data-lang-lbl-contractual") : t("data-lang-lbl-notcontractual"),
            
            displayValue01: item.l_vals && item.l_vals.length > 0 ? item.l_vals[0]?.displayValue?.toLocaleString(i18next.language) : null,
            valueGoal01: item.l_vals && item.l_vals.length > 0 ? item.l_vals[0]?.valueGoal?.toLocaleString(i18next.language) : null,
            valueGoalPercent01: item.l_vals && item.l_vals.length > 0 ? item.l_vals[0]?.valueGoalPercent?.toLocaleString(i18next.language) : null,
            color01: item.l_vals && item.l_vals.length > 0 ? item.l_vals[0]?.color : null,

            displayValue02: item.l_vals && item.l_vals.length > 0 ? item.l_vals[1]?.displayValue?.toLocaleString(i18next.language) : null,
            valueGoal02: item.l_vals && item.l_vals.length > 0 ? item.l_vals[1]?.valueGoal?.toLocaleString(i18next.language) : null,
            valueGoalPercent02: item.l_vals && item.l_vals.length > 0 ? item.l_vals[1]?.valueGoalPercent?.toLocaleString(i18next.language) : null,
            color02: item.l_vals && item.l_vals.length > 0 ? item.l_vals[1]?.color : null,

            displayValue03: item.l_vals && item.l_vals.length > 0 ? item.l_vals[2]?.displayValue?.toLocaleString(i18next.language) : null,
            valueGoal03: item.l_vals && item.l_vals.length > 0 ? item.l_vals[2]?.valueGoal?.toLocaleString(i18next.language) : null,
            valueGoalPercent03: item.l_vals && item.l_vals.length > 0 ? item.l_vals[2]?.valueGoalPercent?.toLocaleString(i18next.language) : null,
            color03: item.l_vals && item.l_vals.length > 0 ? item.l_vals[2]?.color : null,

        }))
        
        : 
        
        [{
            variableName: '',
            um: '',
            displayValue01: 0,
            valueGoal01: 0,
            valueGoalPercent01: 0,
            color01: null,

            displayValue02: 0,
            valueGoal02: 0,
            valueGoalPercent02: 0,
            color02: null,

            displayValue03: 0,
            valueGoal03: 0,
            valueGoalPercent03: 0,
            color03: null,
        }]
    ))

    const getColumngroups = () => {
        const serieTimeColumns = (() => {
            const first = inputParam_ComponentContent?.items[0];
            if (first?.l_vals?.length === 3) {
                    const columnas = first.l_vals.map((p, i) => ({
                    text: p.serieTime.toString(),
                    align: 'center',
                    name: (i + 1).toString()
                }));
                return [
                    { text: t('data-lang-lbl-period'), align: 'center', name: 'Periodo' },
                    ...columnas
                ];
            }
            return [];
        })();
        console.log()
        return serieTimeColumns;
    } 


    useEffect(() => {
        gridRef.current && gridRef.current.addgroup("contractualText");
        gridRef.current.expandallgroups();
    }, []);


    return (
            <Card className='p-0'>
                <Card.Header className="card-header-compact">
                    <Card.Title className="d-flex justify-content-between">
                            {
                                !isNullUndefinedOrEmpty(inputParam_ComponentContent) && !isNullUndefinedOrEmpty(inputParam_ComponentContent.boardComponentTitle) &&
                                <b>{ inputParam_ComponentContent.boardComponentTitle }</b>
                            }
                            {
                                !isNullUndefinedOrEmpty(inputParam_ComponentContent) && isNullUndefinedOrEmpty(inputParam_ComponentContent.boardComponentTitle) &&
                                <b>{t('data-lang-lbl-kpikeys')}</b>
                            }
                    </Card.Title>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col>
                            <JqxGrid
                                ref={gridRef}
                                width="100%"
                                autoheight={false}
                                height={"475px"}
                                source={new jqx.dataAdapter({
                                    localData: data.data,
                                    dataType: 'array',
                                    dataFields: [
                                        { name: 'dataserieId',        type: 'number' },
                                        { name: 'variableName',       type: 'string' },
                                        { name: 'contractualText',    type: 'string' },
                                        { name: 'displayValue01',     type: 'float'  },
                                        { name: 'valueGoal01',        type: 'float'  },
                                        { name: 'valueGoalPercent01', type: 'float'  },
                                        { name: 'displayValue02',     type: 'float'  },
                                        { name: 'valueGoal02',        type: 'float'  },
                                        { name: 'valueGoalPercent02', type: 'float'  },
                                        { name: 'displayValue03',     type: 'float'  },
                                        { name: 'valueGoal03',        type: 'float'  },
                                        { name: 'valueGoalPercent03', type: 'float'  },
                                    ],
                                    id: 'dataserieId'
                                })}
                                columnsresize={true}
                                groupable={true}
                                showgroupmenuitems={false}
                                showgroupsheader={false}
                                groupsrenderer={(text, group, expanded, data) => {
                                    return `${text}`;
                                }}
                                columns={[
                                    { text: t('data-lang-lbl-kpiclass'), datafield: "variableName",       width: '28%', columngroup: 'Periodo' },
                                    { text: t('data-lang-lbl-category'),          datafield: "contractualText",    width: '0%',  hidden: true },
                                    { text: t('data-lang-lbl-field-realvalue'),        datafield: "displayValue01",     width: '8%',  cellsalign: "right", columngroup: '1',
                                        cellsrenderer: (row, columnfield, value) => {
                                            return `<div class="jqx-grid-cell-right-align" style="margin-top: 7.5px;"><div>${formatNumber(value)}</div></div>`;
                                        },
                                    },
                                    { text: t('data-lang-lbl-goal'),              datafield: "valueGoal01",        width: '8%',  cellsalign: "right", columngroup: '1',
                                        cellsrenderer: (row, columnfield, value) => {
                                            return `<div class="jqx-grid-cell-right-align" style="margin-top: 7.5px;"><div>${formatNumber(value)}</div></div>`;
                                        },
                                    },
                                    { text: t('data-lang-lbl-goalpercent'),             datafield: "valueGoalPercent01", width: '8%',  cellsalign: "right", columngroup: '1',
                                        cellsrenderer: (row, columnfield, value) => {
                                            const value_aux = data.data[row].color01;
                                            const colorName = (value_aux === "r" ? 'red' : (value_aux === "a" ? 'orange' : (value_aux === "v" ? 'green' : 'unset')))
                                            return `
                                            <div class="jqx-grid-cell-right-align" style="margin-top: 7.5px;">
                                                <div class="d-flex">
                                                    ${colorName !== 'unset' ? `<i class="ms-Icon ms-Icon--LocationFill me-auto" style="font-size:16px; margin-left:5px;color:${colorName};"></i>` : ''}
                                                    <div>${formatNumber(value)}${!isNullUndefinedOrEmpty(value) ? '%' : ''}</div>
                                                </div>
                                            </div>
                                            `;
                                        },
                                    },
                                    { text: t('data-lang-lbl-field-realvalue'),        datafield: "displayValue02",     width: '8%',  cellsalign: "right", columngroup: '2',
                                        cellsrenderer: (row, columnfield, value) => {
                                            return `<div class="jqx-grid-cell-right-align" style="margin-top: 7.5px;"><div>${formatNumber(value)}</div></div>`;
                                        },
                                    },
                                    { text: t('data-lang-lbl-goal'),              datafield: "valueGoal02",        width: '8%',  cellsalign: "right", columngroup: '2',
                                        cellsrenderer: (row, columnfield, value) => {
                                            return `<div class="jqx-grid-cell-right-align" style="margin-top: 7.5px;"><div>${formatNumber(value)}</div></div>`;
                                        },
                                    },
                                    { text: t('data-lang-lbl-goalpercent'),             datafield: "valueGoalPercent02", width: '8%',  cellsalign: "right", columngroup: '2',
                                        cellsrenderer: (row, columnfield, value) => {
                                            const value_aux = data.data[row].color02;
                                            const colorName = (value_aux === "r" ? 'red' : (value_aux === "a" ? 'orange' : (value_aux === "v" ? 'green' : 'unset')))
                                            return `
                                            <div class="jqx-grid-cell-right-align" style="margin-top: 7.5px;">
                                                <div class="d-flex">
                                                    ${colorName !== 'unset' ? `<i class="ms-Icon ms-Icon--LocationFill me-auto" style="font-size:16px; margin-left:5px;color:${colorName};"></i>` : ''}
                                                    <div>${formatNumber(value)}${!isNullUndefinedOrEmpty(value) ? '%' : ''}</div>
                                                </div>
                                            </div>
                                            `;
                                        },
                                    },
                                    { text: t('data-lang-lbl-field-realvalue'),        datafield: "displayValue03",     width: '8%',  cellsalign: "right", columngroup: '3',
                                        cellsrenderer: (row, columnfield, value) => {
                                            return `<div class="jqx-grid-cell-right-align" style="margin-top: 7.5px;"><div>${formatNumber(value)}</div></div>`;
                                        },
                                    },
                                    { text: t('data-lang-lbl-goal'),              datafield: "valueGoal03",        width: '8%',  cellsalign: "right", columngroup: '3',
                                        cellsrenderer: (row, columnfield, value) => {
                                            return `<div class="jqx-grid-cell-right-align" style="margin-top: 7.5px;"><div>${formatNumber(value)}</div></div>`;
                                        },
                                    },
                                    { text: t('data-lang-lbl-goalpercent'),             datafield: "valueGoalPercent03", width: '8%',  cellsalign: "right", columngroup: '3',
                                        cellsrenderer: (row, columnfield, value) => {
                                            const value_aux = data.data[row].color03;
                                            const colorName = (value_aux === "r" ? 'red' : (value_aux === "a" ? 'orange' : (value_aux === "v" ? 'green' : 'unset')))
                                            return `
                                            <div class="jqx-grid-cell-right-align" style="margin-top: 7.5px;">
                                                <div class="d-flex">
                                                    ${colorName !== 'unset' ? `<i class="ms-Icon ms-Icon--LocationFill me-auto" style="font-size:16px; margin-left:5px;color:${colorName};"></i>` : ''}
                                                    <div>${formatNumber(value)}${!isNullUndefinedOrEmpty(value) ? '%' : ''}</div>
                                                </div>
                                            </div>
                                            `;
                                        },
                                    },
                                ]}
                                columngroups={ getColumngroups() }
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
           );
}

POWERBI_COMPONENT_KEY_KPIS.propTypes = {
    inputParam_ComponentContent: PropTypes.object.isRequired,
    inputParam_UseFake: PropTypes.bool.isRequired,
};

export default POWERBI_COMPONENT_KEY_KPIS;